import * as articles from './ArticlesEndpoints'
import * as events from './EventsEndpoints'
import * as users from './UsersEndpoints'
import * as media from './MediaEndpoints'

export default { articles, events, users, media }
